import { http, cInfrastructures } from "@mainDi/webDi";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./usecases";
import understandUseCases from "../../understandingCommonDI/understandUseCases";
import JwtTokenNestRepository from "@adapters/repositories/Common/JwtTokenNest";
import JwtTokenNestUseCase from "@domains/useCases/Common/JwtTokenNestUseCase";
import ExtPlatDataRetrieveUseCase from "@domains/useCases/Common/ExtPlatDataRetrieveUseCase";
import ExtPlatDataRetrieveRepo from "@adapters/repositories/Common/ExtPlatDataRetrieveRepo";
import RetrieveExtPlatAccDataUseCase from "@domains/useCases/Common/RetrieveExtPlatAccDataUseCase";
var understandUseCase = understandUseCases();
var cRepositorires = repositories(http, cInfrastructures);
var cUseCases = useCases(cRepositorires);
var cActions = actions();
var cPresenters = presenters(cUseCases, cActions, understandUseCase);
export var jwtTokenFetchUseCase = new JwtTokenNestUseCase(new JwtTokenNestRepository(http));
export var extPlatDataRetrieveUseCase = new ExtPlatDataRetrieveUseCase(new ExtPlatDataRetrieveRepo(http));
export var retrieveExtPlatAccDataUseCase = new RetrieveExtPlatAccDataUseCase(new ExtPlatDataRetrieveRepo(http));
export default {
    holdingReport: cPresenters.holdingReport,
};
